export const jobLogsActionTypes = {
	GET_ALL_JOBS: "GET_ALL_JOBS",
	GET_SINGLE_JOB: "GET_SINGLE_JOB",
	GET_JOB_COMMENTS: "GET_JOB_COMMENTS",
	SET_OPEN_MODAL: "SET_OPEN_MODAL",
};
